"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.priceStyles = void 0;
var _textStyles = require("./textStyles");
const priceStyles = theme => ({
  ...(0, _textStyles.textStyles)(theme),
  marginRight: theme.spacing(2),
  whiteSpace: 'nowrap'
});
exports.priceStyles = priceStyles;